import styled from "styled-components"
import Typography from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import BackgroundImage from "gatsby-background-image"

export const Title = styled.h2`
  grid-column: 2 / -2;
  text-align: center;
  color: var(--white);
  ${Typography.mobileTextStyles.MobileHeadingOneSemiBold}
  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingTwoSemiBold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingTwoSemiBold}
  }
`

export const Container = styled.div`
  background-color: var(--slate);
  padding: 64px 0;

  @media (min-width: ${Breakpoints.md}) {
    padding: 48px 0;
  }

  @media (min-width: ${Breakpoints.lg}) {
    padding: 64px 0;
  }
`

export const TitleDivider = styled.div`
  margin-top: 32px;
  grid-column: 2 / -2;
  border-bottom: 1px solid var(--dark-mode-body-grey);
  opacity: 0.4;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 16px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -3;
  }
`

export const TileContainer = styled.div`
  background-color: var(--slate);
  display: grid;
  grid-template-columns: 1fr;
  grid-column: 2 / -2;
  grid-gap: 24px;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
    margin-top: 48px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-top: 64px;
  }
`

export const FeatureCardContainer = styled(BackgroundImage)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 72vw;

  @media (min-width: ${Breakpoints.md}) {
    height: 33vw;
  }

  @media (min-width: ${Breakpoints.lg}) {
    height: 18vw;
    max-height: 256px;
  }
`

export const FeatureCardText = styled.p`
  height: 59px;
  max-height: 59px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: var(--white);
  background-color: #282828e6;
  background-blend-mode: multiply;
  ${Typography.desktopTextStyles.HeadingSixRegular}
  padding: 0 4px;
`
